export const numberOfColumnsLabel = "MGd";
export const numberOfRowsLabel = "NGd";
export default {numberOfColumnsLabel,numberOfRowsLabel};